/*
==========================================================
IMPORTS
==========================================================
*/

import RegisterPage from "./platform/auth/RegisterPage";

/*
==========================================================
PAGE
==========================================================
*/

export default function Register() {

  return <RegisterPage />;

}